/**
 * 商铺在商户主页联系商户记录
 */
import React from 'react';

import { Row, Col, DatePicker, Input, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import Loading from '../../ui/Loading';

class CallMemberIndex extends React.Component {

    columns = [{
        title: '商户名称',
        dataIndex: 'memberName',
        width: '10%',
    }, {
        title: '顾客电话',
        dataIndex: 'telephone',
        width: '10%',
    }, {
        title: '内部用户昵称',
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '内部用户电话',
        dataIndex: 'tel',
        width: '10%',
    }, {
        title: '拨打时间',
        dataIndex: 'insertTime',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false    //导出遮罩
    };

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (field, key) =>{
        let queryData = this.state.queryData;
        queryData[field] = key;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNo = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/mallLog/callMember/download',
            data: queryData,
            fileName: "咨询底价记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="商户名称"
                                    onSearch={this.inputSearch.bind(this, "memberName")}
                                    enterButton
                                    style={{ width: '200px', marginRight: '10px'}}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange}/>
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/mallLog/callMember/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default CallMemberIndex;